import '../tables/Table.module.css'
import classes from '../tables/Table.module.css'
function SubobjectiveTableValidation(props) {

    const colNames =  ['invalid field', 'error type', 'validation error', 'please correct'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);


    function input_interval(key_name, key_id, range_min, range_max, inputHandler){
        const interval = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                id={`${key_name}_min_${key_id}`}
                type='number' 
                placeholder='min' 
                autoComplete='false' 
                value={range_min !== null ? range_min : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                <p style={{margin:'0px', padding:'0px', paddingLeft:'5px', paddingRight:'5px', fontSize: '14px'}}>-</p>
                <input 
                id={`${key_name}_max_${key_id}`}
                type='number' 
                placeholder='max'   
                autoComplete='false' 
                value={range_max !== null ? range_max : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
            </div>
        </>);
    return interval;
    }


    function input_value(key_name, key_id, val, inputHandler){
        const input_field = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                id={`${key_name}_val_${key_id}`}
                type='number' 
                placeholder='value' 
                autoComplete='false' 
                value={val !== null ? val : ''} 
                onChange={inputHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
            </div>
        </>);
    return input_field;
    }


    function input_csv_list(key_name, key_id, list_vals, inputHandler, onBlurHandler){
        let csv_list = '';
        if (list_vals.length > 0) { 
            csv_list = list_vals.join(', ');
        }
        const csv_input = (<>
            <input 
                id={`${key_name}_${key_id}`}
                type='text' 
                placeholder='csv list ...' 
                autoComplete='false' 
                value={csv_list} 
                onChange={inputHandler}
                onBlur={onBlurHandler}
                style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'143px'}}/>
        </>);
    return csv_input;
    }

    function ranking_tier_segment(key_name, key_id, id_segment, segment_data, show_remove, show_add, inputHandler){
        // if all_segments.length > 0
        const selector = (<>
                <select id={`${key_name}_type_${key_id}_${id_segment}`}
                        className={classes.selectObjectiveEditor} 
                        style={{marginRight:'5px'}}
                        value={segment_data.type} 
                        onChange={inputHandler} 
                        name="type">
                    <option value='Interval'>[;]</option>
                    <option value='LE'>{'\u2264'}</option>
                    <option value='L'>{'\u003C'}</option>
                    <option value='GE'>{'\u2265'}</option>
                    <option value='G'>{'\u003E'}</option>
                </select>
            </>);
        
        let input_mask = (<></>);
        if(segment_data.type === 'Interval'){
            let range_min = segment_data.min;
            let range_max = segment_data.max;
            input_mask = input_interval(key_name, `${key_id}_${id_segment}`, range_min, range_max, inputHandler);
        }
        else{
            let val = segment_data.val
            input_mask = input_value(key_name, `${key_id}_${id_segment}`, val, inputHandler);
        }
        
        let add_segment =(<></>);
        if (show_add){
            add_segment = (<>
                    <button 
                            id={`${key_name}_add_${key_id}_${id_segment}`}
                            className={'plus_button'}
                            style={{fontSize:'20px', marginLeft:'5px', marginRight:'5px'}}
                            onClick={inputHandler}>
                    +
                    </button>
                        </>)
        }
        let remove_segment = (<></>);
        if (show_remove){
            remove_segment = (<>
                <button 
                        id={`${key_name}_remove_${key_id}_${id_segment}`}
                        className={'plus_button'}
                        style={{fontSize:'20px', paddingBottom:'5px', marginLeft:'5px',  marginRight:'0px'}}
                        onClick={inputHandler}>
                -
                </button>
                </>)
        }

        const segment = (<>
                    <div key={`${key_name}_${key_id}_${id_segment}`} style={{display:'flex', justifyContent: 'center', alignItems:'center'}}>
                        {selector}
                        {input_mask}
                        {remove_segment}
                        {add_segment}
                    </div>
                          </>);
        return segment
    }
   


    let tableRows = (<></>);
    tableRows = props.invalidFields.map((field, id) => {
        /// FIXME CONTINUE HERE< FIELD NEEDS TO DEBEND ON FIELD NAME! NOT ALWVAYS RELVENTANT RANGE
        let objective = props.subobjective;
        let objective_id = props.subobjective_id
        let field_input = (<></>);
        if (field.name ==='Sub-Score'){
            // field_input = (<></>);
            field_input = (<>
                        <input 
                            id={`is_score_${objective_id}`} 
                            style={{marginTop:'5px'}}
                            onChange={props.inputHandlerScore} 
                            type='checkbox' 
                            checked={objective.is_score}
                        />
                </>);
        }

        else if (field.name === 'Relevant Range')
            {
            if(objective.type === 'Continuous'){
                field_input =  input_interval('range_continuous', objective_id, objective.range_continuous.min, objective.range_continuous.max, props.inputHandler)
            }
            if(objective.type === 'Discrete'){
                field_input =  input_csv_list('range_discrete', objective_id, objective.range_discrete.list_vals, props.inputHandlerCSV, props.onBlurCSV)
            }    
        }
        else if (field.name === 'All Tiers')
            {
            let tiers = [{name:'Target', key:'target'}, {name:'Okay', key:'okay'}, {name:'No-Good', key:'no_good'}]
            field_input = []
            tiers.forEach((tier, id) => {
                if (objective.type === 'Continuous') {
                    field_input.push(<div style={{fontSize:'12px'}}>{tier.name}</div>)
                    let key_name = tier.key;
                    if (key_name === 'no_good') { key_name = 'nogood';}
                    if (objective[tier.key].length === 0 ){
                        let id_segment = -1;
                        field_input.push(<>
                                        <div style={{fontSize:'12px'}}>{tier.name}</div>
                                        <button 
                                                id={`${key_name}_add_${objective_id}_${id_segment}`}
                                                className={'plus_button'}
                                                style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                                onClick={props.inputHandler}>
                                        +
                                        </button>
                                        <div style={{marginBottom:'5px'}}></div>
                                    </>);
                    }
                    else {
                        for(let i=0; i< objective[tier.key].length; i++)
                        {
                            let id_segment = i
                            let show_remove = true;
                            let show_add = false;
                            if(i===objective[tier.key].length-1) {show_add=true;}
                            let segment_data = objective[tier.key][i];
                            field_input.push(ranking_tier_segment(key_name, objective_id, id_segment, segment_data, show_remove, show_add, props.inputHandler));
                            field_input.push(<div style={{marginBottom:'5px'}}></div>);
                        }
                    }
                }
                if (objective.type === 'Discrete') {
                    field_input.push(<div style={{fontSize:'12px'}}>{tier.name}</div>)
                    let list_vals = []
                    if (objective[tier.key].length >0 ){
                        list_vals = objective[tier.key][0].list_vals;
                    }
                    field_input.push(input_csv_list(tier.key, objective_id, list_vals, props.inputHandlerCSV, props.onBlurCSV));
                    field_input.push(<div style={{marginBottom:'5px'}}></div>);
                }
            });
        }
        else if (field.name === 'Isolated Okay'){
            let tiers = [{name:'Okay', key:'okay'}, {name:'Target', key:'target'}]
            field_input = []
            tiers.forEach((tier, id) => {
                if (objective.type === 'Continuous') {
                    field_input.push(<div style={{fontSize:'12px'}}>{tier.name}</div>)
                    let key_name = tier.key;
                    if (objective[tier.key].length === 0 ){
                        let id_segment = -1;
                        field_input.push(<>
                                        <div style={{fontSize:'12px'}}>{tier.name}</div>
                                        <button 
                                                id={`${key_name}_add_${objective_id}_${id_segment}`}
                                                className={'plus_button'}
                                                style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                                onClick={props.inputHandler}>
                                        +
                                        </button>
                                        <div style={{marginBottom:'5px'}}></div>
                                    </>);
                    }
                    else {
                        for(let i=0; i< objective[tier.key].length; i++)
                        {
                            let id_segment = i
                            let show_remove = true;
                            let show_add = false;
                            if(i===objective[tier.key].length-1) {show_add=true;}
                            let segment_data = objective[tier.key][i];
                            field_input.push(ranking_tier_segment(key_name, objective_id, id_segment, segment_data, show_remove, show_add, props.inputHandler));
                            field_input.push(<div style={{marginBottom:'5px'}}></div>);
                        }
                    }
                }
                /// Does not apply for objective.type === 'Discrete' 
            });
        }
        else {
            if (objective.type === 'Continuous') {
                let key_name=field.key;
                if (key_name === 'no_good') { key_name = 'nogood';}
                if (key_name === 'go_criteria') { key_name = 'gocriteria';}
                if (objective[field.key].length === 0 ){
                    let id_segment = -1;
                    field_input = (<>
                                <button 
                                        id={`${key_name}_add_${objective_id}_${id_segment}`}
                                        className={'plus_button'}
                                        style={{fontSize:'20px', marginTop:'4px', marginBottom:'4px', marginLeft:'5px', marginRight:'0px'}}
                                        onClick={props.inputHandler}>
                                +
                                </button>
                            </>);
                }
                else {
                    field_input = []
                    for(let i=0; i< objective[field.key].length; i++)
                    {
                        let id_segment = i
                        let show_remove = true;
                        let show_add = false;
                        if(i===objective[field.key].length-1) {show_add=true;}
                        let segment_data = objective[field.key][i];
                        field_input.push(ranking_tier_segment(key_name, objective_id, id_segment, segment_data, show_remove, show_add, props.inputHandler));
                    }
                }
            }
            if (objective.type === 'Discrete') {
                let list_vals = []
                if (objective[field.key].length >0 ){
                    list_vals = objective[field.key][0].list_vals;
                }
                field_input = input_csv_list(field.key, objective_id, list_vals, props.inputHandlerCSV, props.onBlurCSV)
            }
        }



        return (
            <>
            <tr key={`row_${id}`} style={{ marginBottom: '20px' }}>
                <td key={`field_name_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {field.name}
                    </div>
                </td>
                <td key={`error_type_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {field.error_type.map((msg, idx) => (<div key={idx}>{msg}</div> ))}
                    </div>
                </td>
                <td key={`error_msg_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px', color:'red'}}>
                        {field.err_msg.map((msg, idx) => (<div key={idx}>{msg}</div> ))}
                    </div>
                </td>
                <td key={`${field.key}_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {field_input}
                    </div>
                </td>
            </tr>
            <tr><div style={{height:'10px'}}></div></tr>
            </>
        );
    });





    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default SubobjectiveTableValidation;
